import React from 'react';
import { useNavigate } from "react-router-dom";
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyUser } from "../../../../actions/community/usersActions";
import { selectUserEntities, selectUserIds, setEditId, setBanId } from "../../../../store/community/usersSlice";

import { message, Spin } from "antd";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import {Button, ButtonDestroy, ButtonEdit} from "../../../../componets/Buttons";
import { formattedDate } from "../../../../helpers/DateHelpers";
import Edit from "../Edit";
import Block from "../Block";
import configs from "../../../../configs/configs.json";
import {StopOutlined} from "@ant-design/icons";
import usePermissions from "../../../../hooks/usePermissions";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectUserIds);
  const users     = useAppSelector(selectUserEntities);
  const count     = useAppSelector(state => state.community.users.count);
  const error     = useAppSelector(state => state.community.users.error);
  const status    = useAppSelector(state => state.community.users.status);
  const { write_community } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  function onClickBan(id: EntityId) {
    dispatch(setBanId(id));
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyUser(id));

    if (destroyUser.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyUser.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const User = (id: EntityId) => {
    const user = users[id];

    if (!user) {
      return;
    }

    return (
      <CardImage
        key={user.id}
        link={user.url}
        image={user.avatar_url}
        title={user.name}
        fallback={configs.IMAGES.FALLBACK}
        options={write_community ? [
          <Button key='button-ban' onClick={() => onClickBan(user.id)} title='Block' icon={StopOutlined} />,
          <ButtonEdit key={`edit-${user.id}`} onClick={() => onClickEdit(user.id)} />,
          <ButtonDestroy key={`destroy-${user.id}`} onClick={() => onClickDestroy(user.id)} />
        ] : []}>

        <div className='v-small_text'>
          <small>Seen: {formattedDate(user.launch_at).fromNow}</small>
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(User)}

      {<Pagination total={count} size={limit} />}

      <Edit />
      <Block />
    </>
  );
}

export default _List;
